// @see: https://v8.i18n.nuxtjs.org/getting-started/basic-usage/#translate-with-vue-i18n
export default defineI18nConfig(() => ({
    legacy: false,
    locale: 'fi-FI',
    silentTranslationWarn: true,
    sync: true,
}));
